module.exports = __webpack_public_path__ + "img/calculator.f7d4eb07.svg";